import { Boundaries } from "@planzone/core";
import { events } from "@planzone/events";
import { setRequestStateToPending } from "../../utils/setRequestStateToPending";
import { createStateReducer } from "../../utils/createStateReducer";
import { setRequestStateToSuccess } from "../../utils/setRequestStateToSuccess";
import { setRequestStateToFailure } from "../../utils/setRequestStateToFailure";
import { resetState } from "../../utils/resetState";
import { State, Selector } from "./types";
import { createSelector } from "./selector";
import { allocateResourceError } from "@planzone/dto";

const initialState: State = [];

function handleRequest(
  state: State,
  { task }: Boundaries["allocateResources"]["request"],
) {
  const index = state.findIndex((res) => res.task.uuid === task.uuid);

  return index !== -1
    ? [
        ...state.slice(0, index),
        {
          ...state[index],
          task,
          request: setRequestStateToPending(),
        },

        ...state.slice(index + 1),
      ]
    : [
        ...state,
        {
          ...state[index],
          task,
          allocations: [],
          request: setRequestStateToPending(),
        },
      ];
}

function handleSuccess(
  state: State,
  { task, allocations }: Boundaries["allocateResources"]["success"],
) {
  return state.map((res) =>
    res.task.uuid === task.uuid
      ? {
          task,
          allocations,
          request: setRequestStateToSuccess(),
          error: allocateResourceError,
        }
      : res,
  );
}

function handleFailure(
  state: State,
  { task, error }: Boundaries["allocateResources"]["failure"],
) {
  return state.map((res) =>
    res.task.uuid === task.uuid
      ? { task, request: setRequestStateToFailure(), error }
      : res,
  );
}

const reduceState = resetState(
  initialState,
  createStateReducer(initialState, {
    [events.allocateResourcesRequested]: handleRequest,
    [events.allocateResourcesSucceeded]: handleSuccess,
    [events.allocateResourcesFailed]: handleFailure,
  }),
  [events.changePlanzoneSucceeded],
);

export type { State, Selector };

export { reduceState, initialState, createSelector };
